import {InputNumber} from "antd";
import styles from "./orderRefundForm.module.less";
import {AsyncButton, AsyncButtonPopconfirm} from "digimuth-components/dist";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";

const OrderRefundForm = forwardRef((props: OrderRefundModalProps, ref: React.ForwardedRef<any>) => {
    const [refund, setRefund] = useState<number>(0);

    useImperativeHandle(ref, () => ({
            setRefundValue(value: number) {
                setRefund(value);
            }
        })
    );

    return <div className={styles.container}>
        <div className={styles.text}>Kwota zwrotu:</div>
        <InputNumber
            min={0}
            addonAfter="zł"
            max={props.maxRefund}
            value={refund}
            onChange={e => setRefund(e ?? 0)}/>
        <AsyncButton
            disabled={refund === 0}
            type={"primary"}
            onClick={async () => await props.onSubmit(refund)}
            className={styles.button}
        >
            Zwróć
        </AsyncButton>
        <AsyncButtonPopconfirm
            title={"Czy na pewno chcesz dokonać zwrotu pełnej kwoty?"}
            okText={"Zwróć"}
            onConfirm={async () => await props.onSubmit(null)}
            buttonProps={{className: styles.button}}
        >
            Zwróć pełną kwotę zamówienia
        </AsyncButtonPopconfirm>
    </div>
});

export default OrderRefundForm;

interface OrderRefundModalProps {
    onSubmit: (value: number | null) => Promise<any>,
    maxRefund: number;
}
